import { render, staticRenderFns } from "./OperationRecordsView.vue?vue&type=template&id=53e1d6a5&"
import script from "./OperationRecordsView.vue?vue&type=script&lang=js&"
export * from "./OperationRecordsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports